export default "__VITE_ASSET__2c50d78b__"